import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../hooks/use-encounter-creation-gate";
import {
  PatientFlagsControllerApi,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  archive?: boolean;
  status?: boolean;
  patientUuid?: string;
  gridSorting: GridSortItem[];
  xTENANTID?: string;
  flagUuid?: string;
  searchString?: string;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Atish Bagate]
 */
  export const useGetPatientFlagList = ({
  pagination,
  archive,
  status,
  patientUuid,
  gridSorting,
  xTENANTID,
  flagUuid,
  searchString,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString ?? "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-flag-list",
      pageIndex,
      pagination.pageSize,
      sortDirect, 
      archive, 
      sortBy,
      patientUuid, // patientUuid
      status, // status
      xTENANTID,
      flagUuid
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && !skip,
    queryFn: async () =>
      await new PatientFlagsControllerApi(getConfigObject())
        .getPatientFlags(
          pageIndex, //page
          pagination.pageSize, //size
          sortBy, // sortBy
          sortDirect, // sortDirection
          patientUuid, // patientUuid
          status, // status
          archive,
          flagUuid,
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};